// extracted by mini-css-extract-plugin
export var ErrorBlock = "index-module--ErrorBlock--ef054";
export var WarningMessage = "index-module--WarningMessage--eb291";